import { Users, ArrowRight } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API_URL } from '../../config/api'

interface Props {
  agentId: number
}

interface NetworkNode {
  id: number
  name: string
  role: string // mentor | mentee | sibling
  eq_score?: number
}

export default function AgentNetworkTab({ agentId }: Props) {
  const [nodes, setNodes] = useState<NetworkNode[]>([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    fetch(`${API_URL}/api/agents/${agentId}/network`)
      .then(r => r.ok ? r.json() : { nodes: [] })
      .then(d => { setNodes(d.nodes ?? []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [agentId])

  if (loading) return <div className="ad-loading">Loading network...</div>
  if (!nodes.length) return (
    <div className="ad-empty"><Users size={32} /><p>No network connections yet</p></div>
  )

  const mentors = nodes.filter(n => n.role === 'mentor')
  const mentees = nodes.filter(n => n.role === 'mentee')
  const siblings = nodes.filter(n => n.role === 'sibling')

  const renderGroup = (title: string, items: NetworkNode[]) => {
    if (!items.length) return null
    return (
      <div className="ad-network-group">
        <h4 className="ad-network-group-title">{title} ({items.length})</h4>
        <div className="ad-network-list">
          {items.map(n => (
            <button key={n.id} className="ad-network-node" onClick={() => navigate(`/agent/${n.id}`)}>
              <div className="ad-network-avatar">
                {(n.name ?? 'A').substring(0, 1).toUpperCase()}
              </div>
              <div className="ad-network-info">
                <span className="ad-network-name">{n.name}</span>
                {n.eq_score != null && <span className="ad-network-eq">EQ {Number(n.eq_score).toFixed(1)}</span>}
              </div>
              <ArrowRight size={12} className="ad-network-arrow" />
            </button>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="ad-network">
      {renderGroup('Mentors', mentors)}
      {renderGroup('Mentees', mentees)}
      {renderGroup('Siblings', siblings)}
    </div>
  )
}
